import styles from "./footer.module.scss";

export const Footer = () => {
    return (
        <footer className={styles["container"]}>
            <div className={styles["inner"]}>
                <div className={styles["brand"]}>
                    <p>Desenvolvedor frontend — Fortaleza, CE</p>
                </div>
                <span className={styles["copy"]}>
                    © {new Date().getFullYear()} Matheus Batista
                </span>
            </div>
        </footer>
    );
};

export default Footer;
